/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDButton from "components/MDButton";

// Billing page components
import MUIDataTable from "mui-datatables";

// ##############ICONS IMPORTS################
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { StyledEngineProvider } from "@mui/material/styles";
import React, { useState } from "react";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  IconButton,
  Card,
  Autocomplete,
} from "@mui/material";
import { Box } from "@mui/system";

import "./filters.css";
import { LocalFilters } from "../LocalFilters";
function Filters({ filtersState, setFiltersState, applyFiltersHandler }) {

  const tiposExclusiones = [
    { id: 1, descripcion: "expediente" },
    { id: 2, descripcion: "temporal" },
    { id: 3, descripcion: "permanente" },
  ];
  const [selectedTipoExclusion, setSelectedTipoExclusion] = useState(null);
  // const [localFilters, setLocalFilters] = useState<LocalFilters>(filtersState);

  const handleTipoExclusion = (event) => {
    setSelectedTipoExclusion(event.target.value);
    
  };

  return (
    <StyledEngineProvider injectFirst>
      <div>
        <div className="containerTitle">
          <MDTypography variant="h6" fontWeight="medium">
          Búsqueda de Tipos de Exclusiones
          </MDTypography>
        </div>
        <Divider variant="middle" className="thickDivider" />
        <div className="container">
          <div className="input1">
            {" "}
            <TextField
              id="standard-basic"
              label="Nombre"
              variant="standard"
              value={filtersState.nombre ?? ""}
              onChange={(value) => {
                setFiltersState((prev) => ({ ...prev, nombre: value.target.value }));
              }}
            />
          </div>
          <div className="input2">
            {" "}
            <Autocomplete
                    id="combo-box-demo"
                    getOptionLabel={(option) => option.descripcion ?? ""} // if not found, return empty string to avoid controlled/uncontrolled component warning
                    options={tiposExclusiones}
                    value={selectedTipoExclusion}
                    sx={{ width: 200, marginTop: "10px", marginBottom: "10px" }}
                    renderInput={(params) => <TextField {...params} label="Tipo" />}
                    onChange={
                      (event, newValue) => {
                        //console.log("value", newValue)
                      setSelectedTipoExclusion(newValue);
                      setFiltersState((prev) => ({
                        ...prev,
                        tipo: newValue,
                      }));
                    }}
                  />
          </div>
          <div className="input3">
            {" "}
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filtersState.habilitado}
                    onChange={(value) => {
                      setFiltersState((prev) => ({
                        ...prev,
                        habilitado: value.target.checked,
                      }));
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Habilitado"
              />
            </FormGroup>
          </div>
          {/* <div className="input3">
            {" "}
            <TextField id="standard-basic" label="Fecha de Creacion" variant="standard" />
          </div> */}
        </div>
        <Divider variant="middle" className="thickDivider" />
        <Button
          color="warning"
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={applyFiltersHandler}
        >
          Aplicar
        </Button>
        <Button
          color="warning"
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => {
            setFiltersState({ nombre: "", tipo: null, habilitado: true });
            setSelectedTipoExclusion(null); // will catch in useEffect if values are default, do a backend call
          }}
        >
          Limpiar
        </Button>
      </div>
    </StyledEngineProvider>
  );
}

export default Filters;
